export enum RoutePath {
  LOGIN = '/',
  PARTNERS = '/partners',
  DOC = '/doc',
  DOC_COMPOSITE_PURCHASE = '/doc/composite-purchase',
  DOC_EDIT = '/doc/edit',
  USERS = '/users',
  UNKNOWN_PATH = '*'
}


// WEBPACK FOOTER //
// ./src/constants/RoutePath.ts